import type { PurchasesApi } from "@web/src/app/services/purchases-api";
import { action, makeAutoObservable, runInAction } from "mobx";

export type ProductBillingFrequency =
  | "monthly"
  | "half-yearly"
  | "yearly"
  | "one-time";

export type PurchaseProduct = {
  id: string;
  name: string;
  price: number;
  monthlyPrice: number | null;
  currency: string;
  billingFrequency?: ProductBillingFrequency;
  displayPriceStr: string;
};

export type PurchaseStoreDependencies = {
  purchasesApi: PurchasesApi;
};

export function makePurchaseStore(deps: PurchaseStoreDependencies) {
  return new PurchaseStore(deps);
}

export default class PurchaseStore {
  deps: PurchaseStoreDependencies;

  isPaywallOpen = false;
  products: PurchaseProduct[] = [];

  constructor(dependencies: PurchaseStoreDependencies) {
    makeAutoObservable(this);
    this.deps = dependencies;
  }

  init(userId: string) {
    this.deps.purchasesApi.setUser(userId);
  }

  async loadPurchaseOptions() {
    const products = await this.deps.purchasesApi.getPurchaseOptions();
    runInAction(() => (this.products = products));
  }

  async buy(productId: string, userEmail: string) {
    return await this.deps.purchasesApi.buyProduct(productId, userEmail);
  }

  @action
  setPaywallOpen(isOpen: boolean = true) {
    this.isPaywallOpen = isOpen;
  }
}
